import { render, staticRenderFns } from "./billdetail.vue?vue&type=template&id=b871c466&scoped=true"
import script from "./billdetail.vue?vue&type=script&lang=js"
export * from "./billdetail.vue?vue&type=script&lang=js"
import style0 from "./billdetail.vue?vue&type=style&index=0&id=b871c466&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b871c466",
  null
  
)

export default component.exports